// The press route of the INBOX page (docs/design/inbox.md). A control of
// the page carries a `data-act` that starts with `ib-`. Each block module
// claims one prefix at load (`ib-r-` the record, `ib-s-` SINCE YOU LEFT,
// `ib-n-` NEEDS YOU, `ib-c-` RECENT), and the overlay hands every `ib-` press to
// `inboxPress`, which renders the panel after the handler.

import type { InboxCtx } from './page';

export type InboxPressFn = (act: string, el: HTMLElement, c: InboxCtx) => void;

const routes: [string, InboxPressFn][] = [];

/** Claims the presses whose act starts with `prefix`. */
export function onInboxPress(prefix: string, fn: InboxPressFn): void {
  routes.push([prefix, fn]);
}

/** Hands one press to the module that claimed its prefix; false when no
 *  module claimed it. */
export function inboxPress(act: string, el: HTMLElement, c: InboxCtx): boolean {
  for (const [prefix, fn] of routes) {
    if (act.startsWith(prefix)) {
      fn(act, el, c);
      return true;
    }
  }
  return false;
}
